<template>
  <div id="home_container" class="outer-wrapper height-s-fix">
    <Transition name="image-cover">
      <img src="@/assets/images/header.png" v-if="isGifLoading && !isMobile" alt="" class="img-fluid m-0 image-cover">
    </Transition>

    <div class="">
      <div class="row mx-0">

        <div class="ct-col col-lg-8 p-0 ">
          <div class="col-md-12">
            <Transition name="brand-logo" appear>
              <div class="brand-logo-mob text-left" v-if="!isMobile || (!isGifLoading && isMobile)">
                <img src="/img/icons/radiate-logo.png" width="100px" height="100px" alt="" class="img-fluid">
              </div>
            </Transition>
          </div>
          <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top" v-show="!isGifLoading">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
              @click="toggleNav" aria-controls="navbarSupportedContent" aria-expanded="false"
              aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav">
                <li class="nav-item ">
                  <a class="nav-link" href="#pricing">Pricing </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#FloorPlan">Site & Floor Plan</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#Amenities">Amenities</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#Location">Location</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#VIrtualSV">Virtual Site Visit</a>
                </li>
                <li class="nav-item download-brochure-nav d-flex align-items-center">
                  <a class="nav-link  navbar-last py-0" @click="downloadBrocher()"><img data-v-fae5bece=""
                      src="@/assets/images/download-brocher.gif"> Download Brochure</a>
                </li>
              </ul>
            </div>
          </nav>
          <div class="plan-holder" v-show="!isGifLoading">
            <carousel ref="carousel" :per-page="1" :autoplay="true" :pagination-enabled="false"
              :navigation-enabled="true" :loop="true" :mouse-drag="false" :navigation-prev-label="prevLabel"
              class="home-carousel" :navigation-next-label="nextLabel">
              <slide>
                <img src="/img/icons/image1.jpg" alt="" class="img-fluid m-0">
              </slide>
              <slide>
                <img src="/img/icons/image2.jpg" alt="" class="img-fluid m-0">
              </slide>
              <slide>
                <img src="/img/icons/image3.jpg" alt="" class="img-fluid m-0">
              </slide>
            </carousel>
          </div>
          <div class="about-new" v-show="!isGifLoading">
            <div class="col-12">
              <h3>Signature Towers</h3>
              <h4>Juinagar, Navi Mumbai</h4>
            </div>
            <ProgressBar class="home-progress-bar mob-hide" :steps="formSteps" :activeStepNo="0" />
            <EOIBenefits v-if="isMobile" />
            <div class="info-section mb-mob-20">
              <div class="info-wrapper">
                <div class="row m-0 w-100">
                  <div class="heading-box">
                    <h2 classs="main-heading"> About <span> Signature Towers</span></h2>
                  </div>
                  <div class="col-md-12 amenities-section">

                    <p>Signature Towers, developed by Signature Towers Group is located at the premium location of real
                      Wakad. The construction of the project is in full swing. It consists of 3 Wings with 35 Floors
                      each and is one of the tallest in Pune. Its prime location at the heart of Pune gives you seamless
                      connectivity. Signature Towers is spread across 7 acres of land-parcel including 3 Acres of green
                      space. Wakad is one of the well-developed locality in Pune and well connected to the different
                      part of the city & connected to area like Baner, Pashan, Bavdhan, Aundh, Balewadi, Hinjewadi and
                      Pimpri Chinchwad.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="info-section mb-mob-20" v-show="!isGifLoading">
            <div class="info-wrapper">
              <div class="row m-0 w-100">
                <div class="heading-box">
                  <h2 classs="main-heading">Project <span> Highlights</span></h2>
                </div>
                <div class="col-md-12 amenities-section mb-5">

                  <div class="row mx-0 w-100 mt-3">
                    <div class="col-6 col-md-3">
                      <div class="highlights-box w-100 p-3">
                        <img src="/img/icons/High-1-new.png">
                        <p class="highlight-title">2 & 3BHK Apartments</p>
                      </div>
                    </div>
                    <div class="col-6 col-md-3 ">
                      <div class="highlights-box w-100 p-3">
                        <img src="/img/icons/High-2-new.png">
                        <p class="highlight-title">Vaastu Compliant</p>
                      </div>
                    </div>
                    <div class="col-6 col-md-3">
                      <div class="highlights-box lower-box w-100 p-3">
                        <img src="/img/icons/High-3-new.png">
                        <p class="highlight-title">Possession Coming soon</p>

                      </div>
                    </div>
                    <div class="col-6 col-md-3">
                      <div class="highlights-box lower-box w-100 p-3">
                        <img src="/img/icons/High-4-new.png">
                        <p class="highlight-title">Juinagar, Navi Mumbai</p>
                      </div>
                    </div>

                    <div class="col-md-6 highlights-box-ul">
                      <ul>
                        <li>1.8 km walking boulevard | 2.5 Acres Sunken Garden</li>
                        <li>Ultra-Modern Clubhouse, with Swimming pool</li>
                        <li>Vastu Compliant Residences In Lush Green bounty of Nature</li>
                        <li>Dedicated Bi-cycle parking for children, Common Two-wheeler Parking</li>
                        <li>Entrance Lobby at Podium level</li>
                      </ul>
                    </div>
                    <div class="col-md-6 highlights-box-ul">
                      <ul>
                        <li>AeroDynamic Building Structure | Vehicle-Free Podium</li>
                        <li>Only 3 Towers in 7 Acres | 75% Open Space</li>
                        <li>All Social Amenities Like Schools, Hospitals, Restaurants in 5 Km</li>
                        <li>Aggregate area of recreational Open Space</li>
                      </ul>
                    </div>
                    <div class="col-md-12 download-brocher-section">
                      <a class="download-brocher" @click="downloadBrocher()"><img data-v-fae5bece=""
                          src="@/assets/images/download-brocher.gif"> Download Brochure</a>

                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="scroll-fix" id="pricing"></div>
          <div class="info-section mb-mob-20" v-show="!isGifLoading">
            <div class="info-wrapper">
              <div class="row m-0 w-100">
                <div class="heading-box">
                  <div class="row">
                    <div class="col-7">
                      <h2 classs="main-heading">Project <span>Pricing</span></h2>
                    </div>
                    <div class="col-5 text-right parentTabs">
                      <ul class="nav nav-pills">
                        <li class="nav-item"><a href="#twodplan" id="twoplan-tab" class="nav-link unit-button active"
                            data-toggle="tab" @click.prevent="toggleTab('#twodplan', '#twoplan-tab')">2D </a> </li>
                        <li class="nav-item"><a id="threeplan-tab" href="#threedplan" class="nav-link unit-button"
                            data-toggle="tab" @click.prevent="toggleTab('#threedplan', '#threeplan-tab')">3D </a> </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 amenities-section pricing-section pt-3">
                  <div class="row mx-0 w-100 mt-3">
                    <div id="planTabs" class="mx-auto text-center tab-content">
                      <div class="tab-pane active" id="twodplan">
                        <div class="row pricing-variant-row">
                          <div class="col-md-5 text-center pricing-variant-container">
                            <img src="@/assets/images/2bhk.png" class="w-100">
                            <span><b>2BHK</b></span><br>
                            <span>692 sqft | 75 - 77L Onwards *</span>

                          </div>
                          <div class="col-md-2"></div>
                          <div class="col-md-5 text-center pricing-variant-container">
                            <img src="@/assets/images/2D-2BHK-t2.png" class="w-100">
                            <span><b>2BHK</b></span><br>
                            <span>719 sqft | 79 - 81L Onwards *</span>

                          </div>
                        </div>
                        <div class="row pricing-variant-row">
                          <div class="col-md-5 text-center pricing-variant-container">
                            <img src="@/assets/images/2D-2BHK-t3.png" class="w-100">
                            <span><b>2BHK</b></span><br>
                            <span>779 sqft | 85 - 87L Onwards *</span>

                          </div>
                          <div class="col-md-2"></div>
                          <div class="col-md-5 text-center pricing-variant-container">
                            <img src="@/assets/images/2D-3BHK.png" class="w-100">
                            <span><b>3BHK</b></span><br>
                            <span>903 sqft | 95 - 97L Onwards *</span>

                          </div>
                        </div>

                      </div>
                      <div class="tab-pane" id="threedplan">
                        <div class="row pricing-variant-row">
                          <div class="col-md-5 text-center pricing-variant-container">
                            <img src="@/assets/images/3D_2BHK_t1.png" class="w-100">
                            <span><b>2BHK</b></span><br>
                            <span>692 sqft | 75 - 77L Onwards *</span>

                          </div>
                          <div class="col-md-2"></div>
                          <div class="col-md-5 text-center pricing-variant-container">
                            <img src="@/assets/images/3D-2BHK-t2.png" class="w-100">
                            <span><b>2BHK</b></span><br>
                            <span>719 sqft | 79 - 81L Onwards *</span>

                          </div>
                        </div>
                        <div class="row pricing-variant-row">
                          <div class="col-md-5 text-center pricing-variant-container">
                            <img src="@/assets/images/3D-2BHK-t3.png" class="w-100">
                            <span><b>2BHK</b></span><br>
                            <span>779 sqft | 85 - 87L Onwards *</span>

                          </div>
                          <div class="col-md-2"></div>
                          <div class="col-md-5 text-center pricing-variant-container">
                            <img src="@/assets/images/3D-3BHK.png" class="w-100">
                            <span><b>3BHK</b></span><br>
                            <span>903 sqft | 95 - 97L Onwards *</span>

                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="scroll-fix" id="FloorPlan"></div>
          <div class="info-section mb-mob-20" v-show="!isGifLoading">
            <div class="info-wrapper">
              <div class="row m-0 w-100">
                <div class="heading-box">
                  <h2 classs="main-heading">Site & Floor <span> Plans</span></h2>
                </div>
                <div class="col-md-12 amenities-section mb-5">
                  <div class="row mx-0 w-100 mt-3">
                    <div class="col-md-4 text-center">
                      <a :href="require('@/assets/images/location-big.png')" data-fancybox="gallery" class="block">
                        <img src="@/assets/images/sf1.png" class="w-100 site-plan-img" width="231" height="161"></a>
                      <span class="sf-text">Location Plan</span>
                    </div>
                    <div class="col-md-4 text-center">
                      <a :href="require('@/assets/images/map.png')" data-fancybox="gallery" class="block">
                        <img src="@/assets/images/sf3.png" class="w-100 site-plan-img" height="161" width="231">
                      </a>
                      <span class="sf-text">Master Layout</span>
                    </div>
                    <div class="col-md-4 text-center">
                      <a :href="require('@/assets/images/floor-layout-none.png')" data-fancybox="gallery" class="block">
                        <img src="@/assets/images/sf2.png" class="w-100 site-plan-img" height="322" width="516">
                      </a>
                      <span class="sf-text">Floor Plan </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="scroll-fix" id="Amenities"></div>
          <div class="info-section mb-mob-20" v-show="!isGifLoading">
            <div class="info-wrapper">
              <div class="row m-0 w-100">
                <div class="heading-box">
                  <h2 classs="main-heading">Project <span> Amenities</span></h2>
                </div>
                <div class="col-md-12 amenities-section pt-3">
                  <ul class="row align-order amenities-list">
                    <li class="col-12 col-md-6 pl-0 pb-1">Entrance Gate with Security cabin for 24×7 security</li>
                    <li class="col-12 col-md-6 pl-0 pb-1">Space for Centralized Building Management System</li>
                    <li class="col-12 col-md-6 pl-0 pb-1">Provision of reticulated piped gas through MNGL / Gas Bank
                    </li>
                    <li class="col-6 pl-0 pb-1">Society Office SPACE of WIng - 02</li>
                    <li class="col-12 col-md-6 pl-0 pb-1">Underground Water Tanks</li>
                    <li class="col-12 col-md-6 pl-0 pb-1">Garbage Room</li>
                    <li class="col-12 col-md-6 pl-0 pb-1">Entrance Lobby & Waiting Lounge at Ground level</li>
                    <li class="col-12 col-md-6 pl-0 pb-1">Space for Facility Management</li>
                    <li class="col-12 col-md-6 pl-0 pb-1">Passenger & Fire lifts as per Municipal & Fire Norms</li>
                    <li class="col-12 col-md-6 pl-0 pb-1">Bi-cycle parking for children</li>
                    <li class="col-12 col-md-6 pl-0 pb-1">Main staircase & Fire staircase</li>
                    <li class="col-12 col-md-6 pl-0 pb-1">Common Two-wheeler Parking</li>
                    <li class="col-12 col-md-6 pl-0 pb-1">Services Room</li>
                    <li class="col-12 col-md-6 pl-0 pb-1">Letter box</li>
                    <li class="col-12 col-md-6 pl-0 pb-1">Entrance Lobby at Podium level</li>
                    <li class="col-12 col-md-6 pl-0 pb-1">Index Directory</li>
                    <li class="col-12 col-md-6 pl-0 pb-1">Professionally managed services of common areas, facilities
                      and all amenities by third party</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="scroll-fix" id="Location"></div>
          <div class="info-section mb-mob-20" v-show="!isGifLoading">
            <div class="info-wrapper">
              <div class="row m-0 w-100">
                <div class="heading-box">
                  <h2 classs="main-heading">Project <span> Location</span></h2>
                </div>
                <div class="col-md-12 amenities-section mb-3 map-section">
                  <ProjectLocation />
                </div>
              </div>
            </div>
          </div>
          <div class="scroll-fix" id="VIrtualSV"></div>
          <div class="info-section mb-mob-20" v-show="!isGifLoading">
            <div class="info-wrapper">
              <div class="row m-0 w-100">
                <div class="heading-box">
                  <h2 classs="main-heading">Virtual <span> Site Visit</span></h2>
                </div>
                <div class="col-md-12 amenities-section site-visit-section mb-3">
                  <div class="site-visit">
                    <div class="site-visit-strap text-center">

                      <img src="@/assets/images/play-btn.png" class="play-btn" v-b-modal.virtualTour>
                      <br><br> <span class="site-visit-strap-text ">Virtual Site Tour</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="info-section tnc" v-show="!isGifLoading">
            <div class="info-wrapper">
              <div class="row m-0 ">
                <div class="heading-box">
                  <h2 class="terms-heading">Terms and Conditions</h2>
                  <div class="heading-subtitle"><span>Important things to keep in mind</span></div>
                </div>
                <div class="col-md-12 amenities-section terms-section">
                  <h2 class="headding">Understanding EOI</h2>
                  <ul class="amenities-list">
                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">Generation of EOI is a necessary but not the only step
                      towards booking home at Signature Towers</li>
                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">Only one home will be allocated against a unique EOI
                      number</li>
                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">The EOI generated in one's name is non-transferable and
                      needs to be mandatorily in the name of the individual who will be an applicant in the final home
                      registration</li>
                  </ul>
                </div>
                <div class="col-md-12 amenities-section">
                  <h2 style='color:#000000' class="mt-3 headding">Allotment Rights</h2>
                  <ul class="amenities-list">
                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">Allotment of a home is at the sole discretion of Ganga
                      Asmi and is subject to availability at the time of allotment</li>
                  </ul>
                </div>
                <div class="col-md-12 amenities-section">
                  <h2 style='color:#000000' class="mt-3 headding">Terms Conditions for EOI</h2>
                  <ul class="amenities-list">
                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">
                      Allotment of a home is at the sole discretion of Signature Towers and is subject to availability at the
                      time of allotment
                    </li>

                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">
                      Applications under the Multiplier Rebate Plan "EOI" are now over-subscribed. Customers desirous of
                      an apartment at Dummy Project can still apply online, but will not be eligible for the Multiplier
                      Rebate Plan.
                    </li>

                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">
                      The "Applicant" understands that submitting this Application does not constitute booking a
                      residential apartment at any project being developed by the Promoter, nor does it obligate the
                      Promoter to allot a residential apartment to the Applicant.
                    </li>

                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">
                      Allotment of residential apartments is expected to begin on 7th December 2019 and continue for a
                      period of two calendar weeks thereafter ["Allotment Window"]. All Applicants would be invited for
                      booking a residential apartment of their choice upon opening of the Allotment Window, subject to
                      availability of units for sale.
                    </li>

                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">
                      The Promoter will endeavour to allot residential apartments in a way that meets the preferences
                      selected by applicants while filling their Application, although the actual allotment would be
                      subject to availability, market conditions and sales priorities as determined by the Promoter
                      during the Allotment Window.
                    </li>

                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">
                      Applications are non-transferable. Bookings will be accepted only in the name of applicant(s) as
                      found in the EOI registration. Third party bookings will not be entertained.
                    </li>

                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">
                      Refund of Token Amount - Any applicant who chooses to not avail of a unit allotment during the
                      Allotment Window will receive 100% refund of the EOI Amount paid without any interest or penalty
                      on or before 31 January 2020.
                    </li>
                  </ul>
                  <!-- <ol class="amenities-list">
                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">
                      a. The Promoter means <span class="text-underline-em">PropertyPistol</span>, a Company incorporated under the Companies Act, of 1956.<br/>
                      b.  The term &quot;Premises means and includes Flat as the case may be for which Expression of Interest (EOI) is made.<br/>
                      c. Applicant means any person expressing Interest to purchase the premises and if the context so requires, includes his/her agents or authorized representatives al.<br/>
                      d. Pre Allotment money means the minimum amount of money payable by the Applicant before considering the application for allotment.<br/>
                    </li>
                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">
                      This EOI constitutes an offer by the Applicant to acquire Premises as mentioned in the EOl. The EOl does not confer or constitute any right in favor of the Applicant of allotment and or agreement for the acquisition of the Premises
                    </li>
                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">The completed and duly signed EOl Form is to be submitted to the Promoter along with the Demand Draft Bank Draft/Pay Order/Cheque in favor of &quot;<span class="text-underline-em">PropertyPistol</span>&quot; towards EOI money as shown in the Price and Payment Schedule.</li>
                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">On payment of the Pre Allotment Money by the Applicant and fulfillment of necessary formalities, on <span class="text-underline-em">31st March 2023</span> Promoter propose to open the booking of the premises. Within 15 days from that day, the Applicant will have to option to book the Premises by filing a booking application.</li>
                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">Upon Applicant booking the premises, the Pre Allotment Money shall be treated as part of earnest money, which will be adjusted against the total consideration payable for the sale of Premises.</li>
                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">The Applicant agrees to make a payment due as per the progress of construction, as stated in the payment plan, along with Stamp duty, Registration charges, and GST as applicable and execute the Agreement for Sale as may be drawn up by Promoter under applicable provisions of law/s, within <span class="text-underline-em">15 days</span> from the allotment of Premises and if the applicant falls to get the agreement registered for any reason, Promoter will not be held liable for the same.</li>
                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">The Promoter specifically reserves the right to offer the property and/or the buildings and structures being constructed thereon or any part thereof (save and except the said Premises, as security to any other credit / financial institution, bank or other person/body, who has or may hereafter advance credit, finance or loans to the Promoter.</li>
                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">In the event, the Applicant wishes to withdraw from/cancel this EOl for any reason whatsoever the pre-allotment deposit paid by the Applicant shall be returned within 30 days without any interest thereupon.</li>
                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">All disputes to/arising out of this EOl are subject to the exclusive jurisdiction of Courts in Pune.</li>
                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">The Applicant hereby expressly admits, acknowledges, and confirms that layout, landscaping pathway amenities, and facilities contained/given in any advertisement or brochure, by the Promoter and/or its agents to the applicant and/or his/her/their/its agents is just for the promotional purpose it is expressly understood and agreed by the Applicant that unless such amenities, layout, facilities are contained or incorporated in the agreement for sale, Promoter will not be bound to provide the same to the Applicant. The Promoter further reserves, at its sole discretion, to make such variations, additions, alterations, deletions, and/or modifications in plan and landscaping as stated in the Agreement for Sale as it may deem appropriate or as may be directed by the Competent Authority.</li>
                    <li class="col-12 col-md-12 my-0 ml-0 pl-0"> The Applicant further declares that he has expressed his interest after reading and understanding and/or being explained and having understood the contents of the terms and conditions of EOl and its implications mentioned herein and undertakes not to raise any objections in that regard.</li>
                    <li class="col-12 col-md-12 my-0 ml-0 pl-0">I hereby agree to be bound by these terms and conditions. I hereby confirm that the details provided by me in this EOI form, are true and accurate.</li>
                  </ol> -->
                </div>
              </div>
            </div>
          </div>

        </div>
        <Transition name="right-container">
          <div class="ct-col col-lg-4 right-container mob-hide" v-show="!isGifLoading">
            <!-- <div class="info-section"> -->
            <div class="info-wrapper">
              <div class="row No-padding">
                <div class="col-9">
                  <p>EOI Booking</p>
                  <h2 class="page-heading">Signature Towers </h2>
                  <p class="align-data">Juinagar, Navi Mumbai</p>
                </div>
                <!-- </div> -->
                <div class="col-3">
                  <div class="text-right">
                    <img src="/img/icons/pp-logo-2.png" height="100px" width="100px" alt="" class="img-fluid">
                  </div>
                </div>
                <div class="card-info">
                  <!-- <b-button variant="primary" >Generate EOI</b-button> -->
                  <router-link @click.native="navigate" :to="{ name: 'masterplan', query: { ...this.$route.query } }"
                    class="btn btn-block generate-eoi">Explore Now</router-link>
                </div>
                <EOIBenefits />
                <!-- <KeyProjectHigh /> -->
                <div class="col-12 powered-by">Powered by <span
                    class="powered-by-ppistol ml-1">PropertyPistol&nbsp;Technologies</span></div>
              </div>
            </div>
          </div>
        </Transition>
        <div class="explore-fixed-button col-12 mob-show" v-if="isMobile && !isGifLoading">
          <DownArrow v-show="isMobile && isDownVisible" />
          <div class="card-info">
            <router-link @click.native="navigate" :to="{ name: 'masterplan', query: { ...this.$route.query } }"
              class="btn btn-block generate-eoi">Explore Now</router-link>
          </div>
        </div>
      </div>
    </div>
    <VirtualTour />
  </div>
</template>
<script>

import { Carousel, Slide } from 'vue-carousel';
import { FormSteps } from '@/assets/scripts/utility.js';
import KeyProjectHigh from '../components/Home/KeyProjectHigh.vue';
export default {
  components: {
    ProgressBar: () => import("@/components/ProgressBar.vue"),
    MasterSVG: () => import('@/components/MasterSVG.vue'),
    Typologies: () => import('@/components/Home/Typologies.vue'),
    Carousel,
    Slide,
    VirtualTour: () => import('@/components/VirtualTour.vue'),
    ProjectLocation: () => import('@/components/Home/ProjectLocation.vue'),
    DownArrow: () => import('@/components/Common/DownArrow.vue'),
    EOIBenefits: () => import('@/components/Home/EOIBenefits.vue'),
    // KeyProjectHigh: () => import('@/components/Home/KeyProjectHigh.vue')
  },
  data() {
    return {
      formSteps: FormSteps,
      prevLabel: "",
      show: false,
      nextLabel: "",
      isDownVisible: true

    }
  },
  computed: {
    isLoading() {
      return this.$store.getters.isLoading
    },
    isGifLoading() {
      return this.$store.getters.isGifLoading;
    },
    isMobile() {
      return window && window.innerWidth <= 991;
    }
  },
  watch: {
    isGifLoading(newValue) {
      if (!newValue) {
        this.$refs && this.$refs.carousel && this.$refs.carousel.$forceUpdate();
      }
    }
  },
  methods: {
    toggleTab(id, btnId) {
      $('#planTabs .tab-pane').removeClass('active');
      $(`${id}`).addClass('active');
      $('.nav-pills .unit-button').removeClass('active');
      $(btnId).addClass('active');
    },
    toggleNav() {
      $('#navbarSupportedContent').toggle();
    },
    downloadBrocher() {
      window.open('img/Brochure.pdf', '_blank')
      // window.open('https://s3.ap-south-1.amazonaws.com/enrichr.biz.images/ganga-goel+/Ganga+Asmi_coffee+table+book.pdf')
    },
    navigate() {
      this.$store.dispatch('setLoading', true);
    },
    handleScroll(event) {
      if (Math.abs(event.currentTarget.scrollHeight - event.currentTarget.clientHeight - event.currentTarget.scrollTop) > 60) {
        this.isDownVisible = true;
      } else {
        this.isDownVisible = false;
      }
    }
  },
  created() {
    let userId = this.$route.query.user_id;
    if (userId) {
      userId = btoa(userId);
      this.$router.replace({ query: { user: userId } });
      this.$store.dispatch('setUserId', userId);
      this.$cookies.set('goel-user-id', userId, '1d');
    } else if (this.$route.query.user) {
      this.$store.dispatch('setUserId', this.$route.query.user);
    } else {
      const storedId = this.$cookies.get('goel-user-id');
      if (storedId) {
        this.$store.dispatch('setUserId', storedId);
      } else {
        this.$store.dispatch('setUserId', null);
      }
    }
  },
  mounted() {
    if (this.isMobile) {
      document.getElementById('home_container').addEventListener('scroll', this.handleScroll, { passive: true });
    }
  },
  unmounted() {
    if (this.isMobile) {
      document.getElementById('home_container').removeEventListener('scroll', this.handleScroll);
    }
  }
}
</script>

<style scoped>
.brand-logo-enter-active {
  transition: transform 0.5s ease-in;
  transform: translateY(0);
}

.brand-logo-enter {
  transform: translateY(-200px);
  opacity: 0;
}

.right-container-enter-active {
  transition: transform 0.5s ease-in;
  transform: translateX(0);
}

.right-container-enter {
  transform: translateX(200px);
  opacity: 0;
  position: static;
}

.image-cover {
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  z-index: 1031;
}

.image-cover-leave-from {
  opacity: 1;
}

.image-cover-leave-active {
  transition: opacity 0.5s ease-out 0.5s;
}

.image-cover-leave-to {
  opacity: 0;
}

.plan-holder {
  margin-top: 25px;
}

.plan-holder img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.key-highlights {
  width: 30px;
  height: auto;
  left: 968px;
  top: 293px;
}

.powered-by {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  position: absolute;
  bottom: 20px;
  color: #00000080;
}

.powered-by .powered-by-ppistol {
  color: #000000;
}

.align-order {
  list-style-position: inside;
}

.generate-eoi {
  background: #494899;
  border-radius: 4px;
  font-size: 16px;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
  font-weight: 600;
  box-shadow: none;
}

.generate-eoi:hover {
  background: #615FB4;
  color: #FFFFFF;
}

.pricing-variant-row {
  margin-top: 3rem;
}

.site-plan-img {
  height: 196px;
  max-height: 200px;
}

.mob-show {
  display: none;
}

.No-padding {
  margin: 0;
  padding: 0;
}

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
  right: 0;
  left: 0;
}

.VueCarousel-dot-container {
  display: none !important;
}

.right-container {
  position: absolute;
  display: block;
  right: 0;
  height: 100vh;
  position: sticky;
  top: 0;
  padding: 14px;
  z-index: 1033;
  background: #FFFFFF;
}

.card-info {
  width: 100%;
  margin: 2px;
  background: #FFFFFF;
  border: 1px solid rgba(73, 72, 153, 0.2);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.03);
  border-radius: 10px;
  margin: 16px;
  padding: 16px;
}

.imp-things {
  height: 16px;
  left: 46px;
  top: 1348px;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  /* identical to box height */

  display: flex;
  align-items: center;
}

.info-section {
  /* background: url(../assets/images/about-bg.jpg) no-repeat center 40px; */
  /* padding: 15px; */
  /* border: 6px solid #fff; */
  border-top: none;
  z-index: 1;
  position: relative;
  background-size: cover;
  background: #FFFFFF;
  border: 1px solid rgba(73, 72, 153, 0.2);
  box-shadow: 0px 4px 4px rgb(0 0 0 / 3%);
  border-radius: 10px;
  margin: 16px;
  /* margin-top: -40px; */
}

.info-wrapper {
  background: #fff;
  width: 100%;
  border-radius: 10px;
  display: flex;
}

.info-wrapper h2,
.amenities-section h2 {
  font-size: 12px;
  font-weight: bold;
  color: #000;
  margin-bottom: 10px;
}

.info-wrapper .page-heading {
  font-size: 12px;
  font-weight: bold;
  color: #000;
  font-weight: 700;
  font-size: 24px;
}

.info-wrapper p {
  font-size: 14px;
  color: #00000080;
  line-height: 24px;
  padding: 16px;
  padding-left: 0;
  padding-bottom: 0;
  padding-top: 0;
}

.right-container .info-wrapper p {
  line-height: 10px;
  text-transform: uppercase;
}

.right-container .info-wrapper .align-data {
  text-transform: none;
}

.info-wrapper .align-data {
  font-size: 13px;
  color: #000000;
  line-height: 16px;
  opacity: 0.5;
  text-transform: none;
  padding-left: 0px;
  padding-top: 0;
  margin-bottom: 0;
}

.about-section {
  background: #F5F5F5;
  border-radius: 10px !important;
  padding: 25px;
}

.amenities-section {
  padding-left: 30px;
}

.amenities-section.map-section {
  padding-top: 30px;
}

.amenities-section.terms-section {
  padding-top: 32px;
}

.amenities-section.terms-section .headding {
  margin-top: 0;
}

.amenities-section.key-highlights-section ul li {
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
}

.amenities-section .amenities-list {
  padding-left: 10px;
}

.amenities-section .amenities-list li {
  margin-bottom: 12px;
}

.scroll-fix {
  margin-top: -50px;
  padding-top: 50px;
}


.amenities-section ul li,
.amenities-section ol li {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
}

.sub-list>li {
  list-style-position: outside;
  list-style-type: disc;
  margin-left: 10px;
}

.amenities-section ul:not(.sub-list)>li {
  display: inline-flex;
  list-style-type: none;
}

.amenities-section ul:not(.sub-list)>li:before {
  content: url('../assets/images/ret-dot.png');
  margin-right: 6px;
}

.height-s-fix {
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.brand-logo-mob {
  display: block;
  position: fixed;
  top: 0;
  z-index: 1033;
}

.text-underline-em {
  text-decoration: underline;
  font-weight: 500;
}

@media (max-width: 991px) {
  .info-wrapper {
    position: relative;
    border-radius: 0;
  }

  .side-menu {
    margin-top: 30px;
  }

  .info-section {
    /* background: url(../assets/images/about-bg.jpg) no-repeat center; */
    background-size: cover;
    margin: 0;
  }

  .plan-holder img {
    height: 320px;
    object-fit: cover;
    width: 100%;
  }
}

@media (max-width: 767px) {
  .brand-logo-mob {
    padding: 10px;
    padding-top: 0;
    display: block;
  }
}

.navbar {
  background: #FFFFFF;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.04);
}

.navbar-light .navbar-nav {
  margin-left: 132px;
}

.navbar-light .navbar-nav .nav-link,
.download-brocher {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #000;
  padding-right: 14px;
  padding-left: 14px;
}

.key-highlights-section .download-brocher {
  margin-bottom: 22px;
  display: block;
  padding-left: 0;
  margin-left: -16px;
}

@media (min-width: 1088px) and (max-width:1271px) {
  .navbar-light .navbar-nav .nav-link {
    font-size: 11px;
    padding-right: 10px;
    padding-left: 10px;
  }
}

@media (min-width: 992px) and (max-width:1087px) {
  .navbar-light .navbar-nav .nav-link {
    font-size: 10px;
    padding-right: 8px;
    padding-left: 8px;
  }
}


.navbar-last,
.download-brocher {
  color: #F5821F !important;
  cursor: pointer;
}

.download-brocher:hover {
  text-decoration: none;
}

.navbar-last img,
.download-brocher img {
  height: 30px;
  margin-top: -7px
}

.info-wrapper .heading-box {
  width: 100%;
  height: 56px;
  background: #fbfbfd;
  border-radius: 10px 10px 0px 0px;
  padding: 10px;
  padding-top: 16px;
  padding-left: 20px;

}

.info-wrapper .heading-box h2,
.amenities-section h2 {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #494899;
  opacity: 1;
}

.info-wrapper .heading-box h2.terms-heading {
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
}

.info-wrapper .heading-box .heading-subtitle {
  font-size: 12px;
  color: #00000080;
  /* padding-left: 10px; */
}

.heading-box h2 span {
  font-weight: 600;
  padding-left: 3px;
}

.about-new {
  margin-top: -190px;
  position: relative;
}

.home-progress-bar {
  margin-bottom: 20px;
  margin-left: 32px;
  margin-right: 32px;
}

.about-new h3 {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 34px;
  line-height: 41px;
  color: #FFFFFF;
}

.about-new h4 {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  color: #FFFFFF;
}

.highlights-box {

  background: url(../assets/images/highligt-box.png);
  width: 100%;
  height: 140px;
  background-size: 100% 100%;
  margin-top: 10px;
}

.highlight-title {
  margin-top: 20px;
}

.highlights-box img {
  height: 50px;
  width: 50px;

}

.highlights-box p {

  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #494899;
  opacity: 1;
}

.highlights-box-ul ul>li {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  list-style-type: none;
  margin-left: -40px;
  margin-top: 20px
}

.highlights-box-ul ul li:before {
  content: url('../assets/images/ret-dot.png');
  margin-right: 6px;
}

.download-bro {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  color: #AB3E91;
  opacity: 1;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.heading-box .nav-pills .nav-link,
.nav-pills .show>.nav-link {

  background: #ED7123;
  font-size: 13px;
  line-height: 16px;
  color: #FFFFFF;
  background-color: #494899;
  padding: 5px 20px;
  opacity: 0.5;
  border-radius: 0px
}

.heading-box .nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  opacity: 1;
}

.nav-pills .nav-item:last-child .nav-link {
  border-radius: 0px 4px 4px 0px;
  border: none;
}

.nav-pills .nav-item:first-child .nav-link {
  border-radius: 4px 0px 0px 4px;
  border: none;
}

.sf-text {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  color: #F5821F;
  padding-top: 10px;
}

.site-visit {
  margin-top: 30px;
  background: url(/img/icons/image2.jpg);
  width: 100%;
  Height: 375px;
  background-size: 100% 100%;
  position: relative;

}

.site-visit-strap {
  position: absolute;
  width: 100%;
  height: 89px;
  top: 45%;

  background: rgba(0, 0, 0, 0.22);
  backdrop-filter: blur(42px);
}

.play-btn {
  width: 50px;
  margin-top: -18px;
}

.site-visit-strap-text {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 24px;
  color: #fff;
  margin-top: 20px;
}

.tnc .amenities-section .headding {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: #000000;
  margin-bottom: 8px;
}

.navbar-toggler {
  position: absolute;
  right: 3px;
  top: 10px;
  padding: 2px 6px;
  font-size: 20px;
  border: none;
  background: #ffffff;
}

.navbar-collapse {
  margin-right: -16px;
}

.navbar-collapse .navbar-nav {
  background: #ffffff;
}

.mb-20 {
  margin-bottom: 20px;
}

@media(max-width:768px) {
  .navbar {
    width: 100%;
    height: 50px;
  }

  .about-new {
    position: relative;
  }

}

@media screen and (min-width: 768px) and (max-width: 991px) {


  .navbar {
    height: 50px;
  }

  .navbar-toggler {
    right: 10px;
  }

  .download-brochure-nav {
    padding-top: 16px;
    padding-bottom: 16px;
  }
}

@media (max-width:991px) {
  .mob-hide {
    display: none;
  }

  .image-cover {
    object-fit: cover;
  }

  .mob-show {
    display: revert;
  }

  .explore-fixed-button {
    position: fixed;
    bottom: 0;
    z-index: 1;
    left: 50%;
    transform: translateX(-50%);
    padding: 0;
  }

  .explore-fixed-button .card-info {
    margin: 0;
    border-radius: 0;
  }

  .generate-eoi {
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .about-new {
    margin-top: -100px;
  }

  .about-new h4 {
    padding-bottom: 20px;
  }

  .amenities-section ul:not(.sub-list)>li {
    display: flex;
  }

  .amenities-section .download-brocher-section {
    display: flex;
    justify-content: center;
    margin-top: 50px;
  }

  .mb-mob-20 {
    margin-bottom: 20px;
  }

  .amenities-section.pricing-section {
    padding-left: 62px;
    padding-right: 62px;
  }

  .amenities-section.site-visit-section {
    padding-left: 0;
    padding-right: 0;
  }

  .pricing-variant-container {
    margin-bottom: 70px;
  }

  .pricing-variant-container img {
    margin-bottom: 12px;
  }

  .pricing-variant-row {
    margin-top: 0;
  }

  .amenities-section.map-section {
    padding-left: 0;
    padding-right: 0;
  }

  .tab-content {
    margin-bottom: 0 !important;
  }

  .tnc {
    padding-bottom: 130px;
  }

  .download-brochure-nav {
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .highlights-box.lower-box {
    margin-top: 20px;
  }
}
</style>